/** Official Companies House identity for SMILECONSENT LTD (17506258). */
export const COMPANY = {
  legalName: 'SMILECONSENT LTD',
  tradingName: 'SmileConsent',
  number: '17506258',
  jurisdiction: 'England and Wales',
};

export function companyRegistrationLine() {
  return `${COMPANY.legalName} is registered in ${COMPANY.jurisdiction}. Company number ${COMPANY.number}.`;
}
